import React, { Component } from "react";
import { connect } from "react-redux";
import { AlmacenesPadre } from "./components/AlmacenesPadre";
import "./styles/AlmacenesPadreTab.css";

export default class AlmacenesPadreTab extends Component {
    render() {
        return <AlmacenesPadre />;
    }
}